import SearchAndFilters from 'components/SearchAndFilters';
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { showSuccessToast, showWarningToast } from 'lib/ToastHelper';
import React, { Suspense, useEffect, useState } from 'react';
import Select from 'react-select';
import { Row, Col } from 'reactstrap';
import { companyIdAtom } from 'views/state';
import {
  activationKeyOptionsAtom,
  checkedListAtom,
  orderingAtom,
  paginationConfigAtom,
  serverOrWorkstationFilterAtom,
  filterValuesAtom,
  useOnFilterChangeResetAtoms,
  useCAListFilterValue,
} from './state';
import { caRefreshAtom } from '../state';

const ServerOrWorkstationFilter = [
  { value: '', label: 'All Types' },
  { value: 'Server', label: 'All Servers' },
  { value: 'Workstations', label: 'All Workstations' },
];
const CloudAgentsFilterOptions = [
  { value: 'active', label: 'All Active' },
  { value: 'aging', label: 'Only In Aging Out Process' },
  { value: 'deleted', label: 'Deleted (Aged Out or Manual)' },
];

const colorStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    cursor: 'pointer',
  }),
  option: (styles) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
      cursor: 'pointer',
    };
  },
};
const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const companyId = useAtomValue(companyIdAtom);
  const agentActivationKeysOptions = useAtomValue(activationKeyOptionsAtom);
  const [hostTypeOptions, setHostTypeOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [serverOrWorkstation, setServerOrWorkstation] = useAtom(
    serverOrWorkstationFilterAtom,
  );
  const [checkedList, setCheckedList] = useAtom(checkedListAtom);
  const ordering = useAtomValue(orderingAtom);
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);
  const setCaRefresh = useSetAtom(caRefreshAtom);

  useEffect(() => {
    const fetchHostOptions = async () => {
      // Add non-breaking spaces at the beginning of each label
      const formattedAgentKeys = agentActivationKeysOptions?.map((option) => ({
        ...option,
        label: '\u00A0\u00A0 ' + option.label, // Adding two non-breaking spaces
      }));

      // Filter options containing "Servers" and "Workstations"
      const workstationOptions = formattedAgentKeys?.filter((opt) =>
        opt.label.toLowerCase().includes('workstation'),
      );
      const serverOptions = formattedAgentKeys?.filter(
        (opt) => !opt.label.toLowerCase().includes('workstation'),
      );

      // Merge the lists in the correct order
      const newHostTypeOptions = [
        ServerOrWorkstationFilter[0], // "All Host Types"
        ServerOrWorkstationFilter[1], // "All Servers"
        ...(serverOptions || []), // Add all "Servers" options here
        ServerOrWorkstationFilter[2], // "All Workstations"
        ...(workstationOptions || []), // Add all "Workstations" options here
      ];

      setHostTypeOptions(newHostTypeOptions);
    };

    fetchHostOptions();
  }, [agentActivationKeysOptions]);

  const onSuccessBulkAlias = (response) => {
    setCaRefresh(Math.random().toString());
    if (
      response['cloud_agent_alias_csv'] ===
      response['cloud_agent_alias_updated']
    )
      showSuccessToast(response['message']);
    else showWarningToast(response['message']);
  };

  const setFilterValues = useSetAtom(filterValuesAtom);
  const searchPhrase = useCAListFilterValue<string>('search');
  const selectedCloudAgentsFilter = useCAListFilterValue<
    'active' | 'aging' | 'deleted'
  >('filter');

  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();

  const handleFilterChange = () => {
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left">
        <Col
          md="2"
          sm="12"
          className="text-left"
          style={{ paddingRight: '0px' }}
        >
          <Select
            id="CloudAgentsTypeDropdown"
            className="custom-360-dropdown"
            value={hostTypeOptions.find((x) => x.value === serverOrWorkstation)}
            onChange={(e) => {
              if (e) {
                setPaginationConfig({ ...paginationConfig, page: 1 });

                setServerOrWorkstation(e.value);
                setCheckedList([]);
              }
            }}
            styles={colorStyles}
            options={hostTypeOptions}
          />
        </Col>
        <Col xs="12" md>
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
